<div class="modal-content">
  <div class="modal-header">
    <h3 class="modal-title">CÁLCULO DE RETENÇÃO</h3>
  </div>
  <div class="modal-body" style="font-size: 18px;">
    <h3>Valor Solicitado</h3>
    <p class="text-center">{{ proposta.valorLiquido | currency:'BRL':'symbol':'1.2-2' }}</p>

    <h3>Parcelamento</h3>
    <p class="text-center">{{ parcela.numeroParcelas }}x de {{ parcela.valor | currency:'BRL':'symbol':'1.2-2' }}</p>

    <h3>Retenção</h3>
    <p class="text-center">{{ parcela.percentualRetencao }}%</p>

    <h3>Valor Líquido</h3>
    <p class="text-center">{{ parcela.valorLiquido | currency:'BRL':'symbol':'1.2-2' }}</p>

  </div>
  <div class="modal-footer">
    <div class="row">
      <div class="form-group tab-buttons">
        <a class="bt-back btn btn-border-orange pull-left" (click)="close()"> Fechar</a>
      </div>
    </div>
  </div>
</div>
